<template>
  <transition name="modal-fade">
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      data-backdrop="false"
      v-if="open"
      @click="clickOutside"
    >
      <div class="modal-wrapper mid-spacing" @click="clickInside">
        <slot name="header"></slot>

        <div class="modal-inner" :class="computedModalInnerClass">
          <div class="modal-component" :class="computedModalComponentClass">
            <div class="modal-headers">
              <img v-if="type === 'warning'" :src="warningSrc" />
              <div v-if="title" class="modal-title">{{ title }}</div>
              <div v-if="subtitle" class="modal-subtitle">{{ subtitle }}</div>
            </div>
            <slot />
          </div>
          <div v-if="buttons" class="modal-footer">
            <a
              v-if="type == 'create' && cancelText != null"
              class="cancel"
              @click="cancel()"
            >{{ $t(cancelText) }}</a>
            <button
              v-if="saveText"
              class="btn btn-flat"
              :class="computedModalFooterButtonClass.concat(type == 'warning' ? 'warning' : '')"
              @click="save()"
              :disabled="saveDisabled"
            >{{ $t(saveText) }}</button>
            <button
              v-if="type == 'warning' && showCancelForWarning && cancelText != null"
              class="btn btn-flat"
              :class="computedModalFooterButtonClass"
              @click="cancel()"
            >{{ $t(cancelText) }}</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    type: {
      // Allow different types of modals to exist
      type: String,
      default: "create",
      validator: val => {
        return ["create", "warning"].indexOf(val) !== -1;
      }
    },
    showCancelForWarning: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: "ui.global.cancel"
    },
    saveText: {
      type: String,
      default: "ui.global.save"
    },
    // Include buttons
    buttons: {
      type: Boolean,
      default: true
    },
    clickOutsideClose: {
      type: Boolean,
      default: true
    },
    saveDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      payload: {}
    };
  },
  computed: {
    warningSrc() {
      return require("@/assets/warning-message.svg");
    },
    computedModalComponentClass() {
      let classes = [];
      if (this.type === "warning") {
        classes.push("warning");
      }
      return classes;
    },
    computedModalFooterButtonClass() {
      let classes = [];
      if (
        (this.type === "warning" && this.showCancelForWarning == false) ||
        !this.cancelText
      ) {
        classes.push("single--footer-button");
      }
      if (this.type == "create") {
        classes = classes.concat(["btn-primary", "btn-save"]);
      } else {
        classes = classes.concat(["btn-primary"]);
      }
      return classes;
    },
    computedModalInnerClass() {
      let classes = [];
      if (!this.buttons) {
        classes.push("is-padding-bottom-0");
      }
      return classes;
    },
  },
  methods: {
    clickOutside() {
      if (this.clickOutsideClose) {
        this.$emit("cancel");
      }
    },
    clickInside(event) {
      if (this.clickOutsideClose) {
        event.stopImmediatePropagation();
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (this) this.$emit("save");
    }
  }
};
</script>

<style lang="sass">
.modal
  position: fixed
  left: 0
  top: 0
  height: 100%
  width: 100%
  overflow: hidden
  background: #454A5BA3

  .modal-wrapper
    position: fixed
    top: 50%
    left: 50%
    min-width: 450px
    transform: translateX(-50%) translateY(-50%)
    margin-left: auto
    margin-right: auto
    z-index: 30
    background: #FFF
    border-radius: 5px

    .modal-inner
      position: relative
      padding-bottom: 60px

      .modal-component
        height: 91%
        overflow-y: auto
        overflow-x: hidden
        padding: 40px

        .flex 
          flex-wrap: nowrap
          .field
            &+ .field
              margin-left: 10px
            input
              // Required for Firefox to prevent overlap of fields
              min-width: 0

        &.warning
          display: flex
          flex-direction: column
          align-items: center
          text-align: center

        .modal-headers
          *:last-child
            margin-bottom: 30px

          img
            margin: 0 auto
            + .modal-title,
            + .modal-subtitle
              margin-top: 25px

          .modal-title
            font-size: 24px
            + .modal-subtitle
              margin-top: 15px

          .modal-subtitle
            font-size: 14px
            color: #9298a9

      .modal-footer
        position: fixed
        bottom: 0
        left: 0
        right: 0
        height: 9%
        border-bottom-left-radius: 5px
        border-bottom-right-radius: 5px
        display: flex
        justify-content: space-between
        align-items: center
        background-color: #F3F5F6
        padding: 0 30px
        min-height: 65px

        button
          &.single--footer-button
            margin: auto
          &.warning
            background-color: #dd6b50
            border-color: #dd6b50

        .cancel
          color: $sensual
          cursor: pointer
          font-size: 14px
          font-weight: $font-medium
          transition: all .15s ease-out
          &:hover
            color: $sensual-dark
          &:active
            color: $sensual-darker

.modal-fade-enter-active,
.modal-fade-leave-active
  transition: opacity .15s
.modal-fade-enter,
.modal-fade-leave-to
  opacity: 0
.modal-fade-enter-to
  opacity: 1

@media only screen and (max-width: 768px)
  .modal-inner
    max-height: unset
@media(max-width: 576px)
  .modal-wrapper
    min-width: 320px
  .modal-component
    padding: 30px

</style>



// WEBPACK FOOTER //
// NewModal.vue?1b6d79f2